import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Logger } from '@app/core';
import { FilterService } from '@progress/kendo-angular-grid';
import { FormBuilder } from '@angular/forms';
import { CustomKendoFilter } from '@app/shared/kendo/custom-kendo-filter';

const log = new Logger('KendoEventSelectComponent');

@Component({
  selector: 'app-kendo-event-select',
  templateUrl: './kendo-event-select.component.html',
  styleUrls: ['./kendo-event-select.component.scss'],
})
export class KendoEventSelectComponent extends CustomKendoFilter implements OnInit, OnChanges {
  @Input() field = 'event_id';

  constructor(private formBuilder: FormBuilder, filterService: FilterService) {
    super(filterService);
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      event_id: [null],
      event: [null],
    });

    const event = this.getObjectFromStorage(this.field, 'events');

    if (event) {
      setTimeout(() => {
        this.form.patchValue({
          event: event,
          event_id: event.id,
        });
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    // Изчиства формата
    // Използва се, за да чисти филтрите, когато се сетне null state на таблицата
    if (this.form && changes && changes.filter && !changes.filter.currentValue) {
      this.form.reset();
    }
  }

  onSelect(event: any) {
    CustomKendoFilter.pushObjectInStorage(event, 'events');

    log.debug(this.filter);
    this.filter = this.removeFilter(this.field);

    const filters = [];
    if (event) {
      filters.push({
        field: this.field,
        operator: 'eq',
        value: event.id,
      });
    }

    const root = this.filter || {
      logic: 'and',
      filters: [],
    };

    if (filters.length) {
      root.filters.push(...filters);
    }
    this.filterService.filter(root);
    log.debug('filters', filters);
  }
}
